import { uuidv4, asString, trimObj, Component, delegateProperties, getOrComputeFromStorage } from '@miso.ai/commons';
const PLUGIN_ID = 'std:user';
export default class UserPlugin extends Component {
  static get id() {
    return PLUGIN_ID;
  }

  constructor() {
    super('user');
    this._contexts = new WeakMap();
  }

  install(MisoClient, context) {
    context.addSubtree(this);
    MisoClient.on('create', this._injectClient.bind(this));
    context.addPayloadPass(this._modifyPayload.bind(this));
  }

  _injectClient(client) {
    const context = new UserContext(this);

    this._contexts.set(client, context);

    delegateProperties(client.context, context, ['anonymous_id', 'user_id', 'user_hash']);
  }

  _modifyPayload(_ref) {
    let {
      client,
      apiGroup,
      apiName,
      payload
    } = _ref;
    return apiGroup === 'interactions' && apiName === 'upload' ? this._modifyPayloadForInteractions(client, payload) : this._modifyPayloadForOthers(client, payload);
  }

  _modifyPayloadForOthers(client, payload) {
    const {
      user_id,
      user_hash,
      anonymous_id
    } = client.context;
    const userInfo = user_id ? {
      user_id,
      user_hash
    } : {
      anonymous_id
    };
    return Object.assign({}, userInfo, payload);
  }

  _modifyPayloadForInteractions(client, _ref2) {
    let {
      data
    } = _ref2;
    const {
      anonymous_id,
      user_id
    } = client.context;
    const baseObj = trimObj({
      anonymous_id,
      user_id
    });
    data = data.map(obj => Object.assign({}, baseObj, obj));
    return {
      data
    };
  }

}

function getAutoAnonymousId() {
  return getOrComputeFromStorage('miso_anonymous_id', uuidv4);
}

class UserContext {
  constructor(plugin) {
    this._plugin = plugin;
  }

  get anonymous_id() {
    return this._anonymousId || this._autoAnonymousId || (this._autoAnonymousId = getAutoAnonymousId());
  }

  set anonymous_id(value) {
    value = asString(value);
    this._anonymousId = value;

    this._plugin._events.emit('set', `anonymous_id = '${value}'`);
  }

  get user_id() {
    return this._userId;
  }

  set user_id(value) {
    value = asString(value);
    this._userId = value;

    this._plugin._events.emit('set', `user_id = '${value}'`);
  }

  get user_hash() {
    return this._userHash;
  }

  set user_hash(value) {
    if (typeof value !== 'string' && typeof value !== 'undefined') {
      throw new Error(`User hash must be a string`);
    }

    this._userHash = value;

    this._plugin._events.emit('set', `user_hash = '${value}'`);
  }

}